import React from "react";
import SearchLogo from "../../assets/logo (2).svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { Image } from "react-bootstrap";

function Footer() {
  return (
    <footer>
      <div className="footer-bottom wide-container text-dark">
        <div className="text-center">
          Copyright &copy; 2025 Se-Arch. All Rights Reserved
        </div>
        <div className="social">
          <a href="#" target="_blank" title="Facebook">
            <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
          </a>
          <a href="#" target="_blank" title="Linkedin">
            <FontAwesomeIcon icon={faLinkedinIn} className="social-icon" />
          </a>
          <a href="#" target="_blank" title="Instagram">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
